import { alpha } from "@mui/material/styles"
import { dsColorNew } from "@palette"


const overridePaperStyles = theme => ({
	MuiPopover: {
		styleOverrides: {
			paper: {
				backgroundColor: dsColorNew.white,
				border: `1px solid ${dsColorNew.grayBorder}`,
				borderRadius: 12,
				boxShadow: `0 12px 32px ${alpha(dsColorNew.navy, 0.12)}`,
			},
		},
	},
	MuiPaper: {
		styleOverrides: {
			root: {
				backgroundColor: dsColorNew.white,
				boxShadow: "none",
			},
		},
	},
	MuiAccordion: {
		styleOverrides: {
			root: {
				"&.Mui-expanded": {
					boxShadow: "none",
					backgroundColor: dsColorNew.white
				},
			},
		},
	},
	MuiAccordionSummary: {
		styleOverrides: {
			root: {
				minHeight: "0px",
				"&.Mui-expanded": {
					minHeight: "0px",
				},
			},
		},
	},
})

export default overridePaperStyles
